const HIGHLIGHTS = [
  {
    icon: 'ri-water-flash-line',
    title: 'Multiple Cascades',
    desc: 'Glen Falls drops in three distinct tiers, each offering a different perspective of the falls and surrounding gorge.',
  },
  {
    icon: 'ri-walk-line',
    title: 'Scenic Hiking Trail',
    desc: 'A well-maintained trail winds alongside the falls, offering views at each level and connecting to the broader Highlands trail network.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Easy to Reach',
    desc: 'Located just minutes from downtown Highlands, Glen Falls is one of the most accessible waterfalls in the area — no long drive required.',
  },
  {
    icon: 'ri-camera-line',
    title: 'Year-Round Beauty',
    desc: 'From spring wildflowers to fall foliage and winter ice formations, Glen Falls offers a different experience in every season.',
  },
];

export default function AboutGlenFallsSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Image */}
          <div className="rounded-2xl overflow-hidden h-[480px]">
            <img
              src="https://public.readdy.ai/ai/img_res/a525b3e5b7faeb010d9172601d5331f1.jpg"
              alt="Glen Falls waterfall cascading through forest in Highlands NC"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Content */}
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ About the Falls</p>
            <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light mb-6">
              What Makes Glen Falls<br /><em className="italic">Worth Staying Near</em>
            </h2>
            <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-5">
              Glen Falls is widely considered one of the most beautiful waterfalls in Highlands, NC. Unlike many waterfalls that require a long hike to reach, Glen Falls is accessible within minutes of downtown — making it a natural anchor for a cabin stay in the area.
            </p>
            <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-10">
              The falls drop in three distinct tiers through a forested gorge, with a scenic trail running alongside each level. Staying in a cabin near Glen Falls means you can visit at different times of day, explore the trail at your own pace, and experience the falls in different light and weather conditions throughout your stay.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {HIGHLIGHTS.map((item) => (
                <div key={item.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#2D4A3E] text-base`} />
                  </div>
                  <div>
                    <h3 className="font-cormorant text-lg text-[#1A1A18] font-medium mb-1">{item.title}</h3>
                    <p className="text-[#9C9890] text-xs font-jost leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
